<template>
    <div class="comment-submit" ref="commentSubmitRef">
        <div class="box">
            <textarea 
                ref="commentEditor"
                placeholder="来说两句吧......" 
                :rows="maxRow" 
                @focus="handleFocus(3)" 
                v-model="comment" 
                :class="!isLogin&&'textarea-unlogin'"
            />
            <div v-if="!isLogin&&!isFocus" class="unlogin-unfocus" @click="login">{{ unLoginSubmitText }}</div>
        </div>
        <!-- 已登录 -->
        <div class="login-btns" v-if="isLogin">
            <!-- 头像 -->
            <a href="https://passport.sohu.com/" v-if="showUser">
                <img class="avatar" :src="userInfo.avatar"/>
                <span class="username">{{userInfo.nickname}}</span>
            </a>
            <!-- 表情 -->
            <div class="emoji" @click.stop="handleShowEmoji">
                <Emoji v-if="showEmoji" @chooseEmoji="chooseEmoji"/>
            </div>
            <!-- 图片 -->
            <div class="pics" @click="chooseImg">
                <UploadImg v-if="showUploadImg" :uploadedImg="unPbulishImgBase64" @closeUploadImg="closeUploadImg"/>
            </div>
            <input
                name="file"
                type="file"
                accept="image/jpg,image/jpeg,image/webp,image/png,image/gif"
                ref="imgInputRef"
                class="img-input"
                @change="handleFileChange"
            />
            <div class="icon-at" @click.stop="handleClickAt">
                <AtUserList
                    v-if="showAtList"
                    ref="searchUser"
                    :articleId="articleId" 
                    :accountId="accountId" 
                    @selectUser="handleAtUser"
                    @hide="showAtList = false"
                />
            </div>
            <div class="submit" @click="handlePublish">{{ loginSubmitText }}</div>
        </div>
        <!-- 未登录 -->
        <div class="un-login-btns" v-if="showLoginBtn">
            <div class="left">
                <span>快速登录：</span>
                <a class="instanse" @click="login" href="javascript:;" />
                <!-- 微信 -->
                <a class="wechat" @click="thirdLogin('wx')" href="javascript:;" />
                <!-- QQ -->
                <a class="qq" @click="thirdLogin('qq')" href="javascript:;"/>
                <!-- 微博 -->
                <a class="wb" @click="thirdLogin('wb')" href="javascript:;"/>
            </div>
            <div class="submit" @click="login">{{ unLoginSubmitText }}</div>
        </div>
    </div>
</template>
<script>
import Emoji from './Emoji.vue'
import UploadImg from './UploadImg.vue'
import AtUserList from './AtUserList.vue'
import { uploadImg,publishComment,getUserInfo } from '../../request/request'
import { getCookie } from "mpfe-utils"
import localstorageUtil from "@/_utils/localstorageUtil";
import Util from '../../_utils/util';
import { importLogin } from '@/utils/login'
import spm_utils from '@/utils/spm_utils';
import { acodeConfig } from '@/config/spmConfig';
import { CommentStore } from '@/store/index'

export default{
    name: 'Publish',
    props: {
        showUser: {
            default: false,
            type: Boolean
        },
        data:{},
    },
    components: {
        Emoji,
        UploadImg,
        AtUserList,
    },
    computed: {
        publishInfo() {
            return this.data
        },
        showLoginBtn() {
            return !this.isLogin&&this.isFocus
        },
        canPublish(){
            const hasCommentText = this.comment && this.comment?.trim() !== ''
            const hasImg = Boolean(this.unPublishImgUrl)
            return hasCommentText || hasImg
        },
        articleId(){
            return window.pcArticleInfo?.news_id
        },
        accountId(){
            return window.pcArticleInfo?.media_id
        },
        showFirstComment() {
            return CommentStore.showFirstComment
        },
        // 未登录
        unLoginSubmitText() {
            return this.showFirstComment? '登录抢首评' : '登录并发表'
        },
        // 已登录
        loginSubmitText() {
            return this.showFirstComment? '抢首评' : '发布'
        },
    },
    watch: {
        showLoginBtn(_new,_old) {
            if(_new) {
                this.$nextTick(()=>{
                    window.sohuSpm?.domDidChange({
                        target: 'comment'
                    });
                })
            }
        }
    },
    data(){
        return {
            maxLength: 1000, // 最大长度
            isLogin: false, // 登录态
            focusUnlogin: false,
            isFocus: false, // 输入框是否聚焦
            comment: '',
            userInfo: {}, // 用户信息
            maxRow: 1,
            showEmoji: false, // 表情
            unPublishImgUrl: '', // 待发布图片url(已上传)
            unPbulishImgBase64: '', // 待发布预览图片
            showUploadImg: false, // 预览图片
            publishFunc: undefined, // 发布评论的事件
            isCommentFinish: true, // 评论是否完成，用于控制评论串行发布，避免评论重复
            commentParams: null, // 评论发布携带参数
            selectUserList: [], // 记录@用户列表
            showAtList: false, // 展示@用户列表
        }
    },
    mounted() {
        // 判断是否登录
        if(getCookie('ppinf')) {
            this.isLogin = true
            this.handleGetUserInfo()
        }
        window.EVENT_BUS.$on('loginSuccess',this.listenLoginSuccess)
        this.handleCommentCache()
    },
    methods: {
        // 监听登录成功
        listenLoginSuccess() {
            this.isLogin = true
            this.handleGetUserInfo()
            this.handleCommentCache()
        },
        // 获取用户信息
        handleGetUserInfo() {
            if(!window?.userInfo?.userId && getCookie('ppinf')) {
                getUserInfo().then((res)=>{
                    if(res.code == 1 && res.data) {
                        this.userInfo = res.data
                        window.userInfo = res.data
                    }
                })
            }
        },
        handleFocus(row,borderColor='#ee4046') {
            this.isFocus = true
            this.maxRow = row
            this.$refs.commentSubmitRef.style.borderColor=borderColor
        },
        // 关闭图片预览&删除图片
        closeUploadImg() {
            this.unPublishImgUrl = ''
            this.unPbulishImgBase64 = ''
            this.showUploadImg = false
        },
        // 展示emoji选择框
        handleShowEmoji(flag=true) {
            this.showEmoji = flag
        },
        // 选择表情
        chooseEmoji(emoji) {
            if(emoji) {
                this.comment = this.comment + emoji?.code
            }
            this.handleShowEmoji(false)
        },
        // 选择图片
        chooseImg() {
            spm_utils.sendAction(acodeConfig.clickImgUpload, `url:${window.location.href};articleId:${this.articleId};accountId:${this.accountId};`)
            this.$refs.imgInputRef.click()
        },
        // 图片上传
        handleFileChange(event) {
            const file = event.target.files[0]; // 获取选择的文件
            const clkParamObj = {
                articleId: this.articleId,
                accountId: this.accountId,
                url: window.location.href
            }
            if(file) {
                var formData = new FormData()
                formData.append('imgFile', file)
                uploadImg(formData).then((result)=>{
                    this.unPublishImgUrl = result && result.data && result.data.cdnUrl
                    this.showUploadImg = true

                    const reader = new FileReader();
                    reader.onload = () => {
                        this.unPbulishImgBase64 = reader.result; // 将图片内容赋值给imageUrl，实现预览
                    };
                    reader.readAsDataURL(file);
                    clkParamObj.status = 'success'
                    clkParamObj.code = result.code
                    clkParamObj.message = result.message
                }).catch((error)=>{
                    clkParamObj.status ='error'
                    clkParamObj.reason = error.message
                    clkParamObj.stack = error.stack
                }).finally(()=>{
                    const clkParam = Object.keys(clkParamObj).map(key => `${key}:${clkParamObj[key]}`).join(';')
                    spm_utils.sendAction(acodeConfig.imgUpload, clkParam)
                })
            }
            this.$refs.imgInputRef.value = '' // 清空文件选择框内容，避免再次选择同样文件不触发事件
        },
        // 发布评论参数
        formatParams() {
            const pcArticleInfo = window.pcArticleInfo
            const content = this.replaceAt(this.comment)
            const p = {
                topic_title: pcArticleInfo?.title,
                topic_url: window.location.href,
                reply_id: this.publishInfo?.id || 0,
                topic_id: this.publishInfo?.topicId,
                attachment_urls: this.unPublishImgUrl,
                content: content,
                media_id: this.accountId,
                source_id: 'mp_'+ this.articleId,
                channel_id: pcArticleInfo?.channel_id,
                requestId: getCookie("SUV") + '_' + new Date().getTime(), // 标记前端评论唯一标识
            }
            return p
        },
        // 发布评论
        handlePublish(e,params) {
            this.commentParams = params
            if(!this.publishFunc){
                this.publishFunc = Util.debounce(()=> {
                    const p = this.commentParams ? this.commentParams : this.formatParams() // 这里不直接使用params,是因为直接使用变成了闭包，params值不变
                    if(!this.canPublish) {
                        this.$toast('请输入内容或图片',2000)
                        return
                    }
                    this.isCommentFinish = false
                    const clkParamObj = {
                        articleId: this.articleId,
                        accountId: this.accountId,
                        url: window.location.href
                    }
                    publishComment(p).then((res)=>{
                        if(res.code === 200 && res.data) {
                            // 假显示
                            const comment = Object.assign({},res.data,{isFake:true,commentStatus:1})
                            if(comment?.parents?.length) {
                                comment.parentsTree = this.creatTreeFromArray(comment?.parents)
                            }
                            // 组装作者信息
                            const userId = res.data?.userId
                            const user = {[userId]: Object.assign(window.userInfo || {}, {userName:window.userInfo?.nickname}) }
                            window.EVENT_BUS.$emit('addFakeComment',{comment, user})
                            CommentStore.setShowFirstComment(false)
                            this.$toast('发布成功',2000)
                            // 恢复默认样式
                            this.restoreStyle()

                            // 滚动到“最新评论”位置
                            this.$nextTick(()=>{
                                var newCommentElement = document.getElementById('newComment')
                                if(newCommentElement)newCommentElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            })
                            clkParamObj.status = 'success'
                            clkParamObj.commentId = res.data?.id
                            clkParamObj.code = res.code
                            clkParamObj.message = res.msg
                        }else if(res.code == 417) { // 封禁禁言通知
                            window?.EVENT_BUS?.$emit('showBannedNotice')
                            clkParamObj.status = 'fail'
                            clkParamObj.code = res.code
                            clkParamObj.message = res.msg
                        }else {
                            clkParamObj.status = 'fail'
                            clkParamObj.code = res.code
                            clkParamObj.message = res.msg
                            this.$toast('发布失败',2000)
                        }
                    }).catch((error)=>{
                        clkParamObj.status = 'error'
                        clkParamObj.reason = error.message
                        clkParamObj.stack = error.stack
                        console.log('评论发布失败', error)
                    }).finally(()=>{
                        this.isCommentFinish = true
                        const clkParam = Object.keys(clkParamObj).map(key => `${key}:${clkParamObj[key]}`).join(';')
                        spm_utils.sendAction(acodeConfig.commentSubmit, clkParam)
                    })
                }, 100)
            }
            this.isCommentFinish && this.publishFunc()
        },
        // parents转成tree结构
        creatTreeFromArray(arr,index = arr.length) {
            if (arr.length === 0) {
            return null;
            }
            const obj = {
                ...arr[0],
                index,
                parentsTree: null
            };
            const restOfArray = arr.slice(1);
            if (restOfArray.length > 0) {
                obj.parentsTree = this.creatTreeFromArray(restOfArray,index-1);
            }
            return obj;
        },
        // 收起评论,恢复默认样式
        restoreStyle() {
            this.$emit('closePublish')
            this.closeUploadImg()
            this.comment = ''
            this.isFocus = false
            this.handleFocus(1,'#b7b7b7')
        },
        // 调起登录弹窗
        login() {
            this.commentPublishCache()
            importLogin().then((res)=>{
                const loginIndex = res.loginIndex
				loginIndex.login()
            })
        },
        // 三方登录（调起登录组件）
        thirdLogin(type) {
            const obj = {
                'wx': '.login-pop .wx a',
                'wb': '.login-pop .sinat a',
                'qq': '.login-pop .qq a',
            }
            const domName = obj[type]
            if(domName) {
                this.commentPublishCache()
                document.querySelector(domName)?.click()
            }
        },
        // 缓存未登陆时待发布的评论
        commentPublishCache() {
            if(!this.unPublishImgUrl && !this.comment) return
            const p = this.formatParams()
            localstorageUtil.setItem('unpublishedComment',p)
        },
        // 处理缓存中的评论
        handleCommentCache() {
            if(this.isLogin) {
                const unpublishedComment = localstorageUtil.getItem('unpublishedComment')
                if(unpublishedComment?.source_id == 'mp_'+this.articleId) {
                    this.handlePublish('',unpublishedComment)
                }
                localstorageUtil.removeItem('unpublishedComment')
            }else {
                localstorageUtil.removeItem('unpublishedComment')
            }
        },
        handleClickAt() {
            console.log('点击表情按钮')
            this.showAtList = !this.showAtList
            spm_utils.sendAction(acodeConfig.clickAtButton, `url:${window.location.href};articleId:${this.articleId};accountId:${this.accountId};`)
        },
        handleAtUser(userItem){
            console.log('选择用户',userItem)
            const isSelect = this.selectUserList.find(o => o.userId == userItem.userId);
            if (!isSelect) {
                this.selectUserList.push(userItem);
            }
            const atStr = `@${userItem.nickname} `
            this.comment = this.comment + atStr
            this.$refs.commentEditor?.focus()
            this.showAtList = false
        },
        /**
         * @description 格式化评论文本内容，将艾特用户文字替换为特殊格式节点字符串
         * 如：“@张三 评论内容” => “<uLabel userId="123456" userName="张三">张三</uLabel> 评论内容”
         * @param str 
         */
         replaceAt(str) {
            try {
                if (str.includes('@')) {
                    this.selectUserList.forEach(item => {
                        const itemReg = new RegExp('@' + item.nickname, 'g');
                        const userInfo = {
                            id: item.userId,
                            name: item.nickname,
                            biz: item.bizId || null,
                            type: item.type
                        }
                        const userInfoStr = JSON.stringify(userInfo)
                        const atLabel = `<uLabel userInfo=${userInfoStr}></uLabel>`
                        str = str.replace(itemReg, atLabel);
                    })
                }
                console.log('替换后的评论内容',str)
                return str
            } catch (error) {
                console.log('替换评论内容异常',error)
                return str
            }
        },
    }

}
</script>
<style lang="less" scoped>
.comment-submit {
    margin-top: 5px;
    position: relative;
    border: 1px solid #b7b7b7;
    .box {
        padding: 7px 10px 0 15px;
        textarea {
            color: #333;
            line-height: 22px;
            width: 100%;
            border: none;
            outline: none;
            resize: none;
            appearance:none;
            padding: 0;
            margin: 0;
            font-size: 14px;
            box-sizing: border-box;
            margin-bottom: 2px;
        }
        .textarea-unlogin {
            margin-bottom: 4px;
        }
        textarea::placeholder {
            color:#ccc;
        }
        .unlogin-unfocus {
            position: absolute;
            top: 0;
            right: 0;
            width: 90px;
            height: 37px;
            font-size: 14px;
            font-family: "Microsoft YaHei";
            line-height: 37px;
            color: #fff;
            background: #d81519;
            cursor: pointer;
            text-align: center;
        }
    }
    .login-btns {
        padding: 0 0 0 10px;
        font-size: 14px;
        height: 35px;
        display: flex;
        align-items: center;
        background-color: #f8f8f8;
        a {
            display: flex;
            align-items: center;
            .avatar {
                width: 26px;
                height: 26px;
                border-radius: 50%;
            }
            .username {
                padding: 0 6px;
                color: #d92227;
                display: inline-block;
            }
        }
        .emoji {
            position: relative;
            cursor: pointer;
            width: 35px;
            height: 35px;
            background: url('../../images/face.png') no-repeat center;
        }
        .emoji:hover {
            background: url('../../images/face-active.png') no-repeat center;
        }
        .pics {
            cursor: pointer;
            width: 35px;
            height: 35px;
            background: url('../../images/image.png') no-repeat center;
        }
        .pics:hover {
            background: url('../../images/image-active.png') no-repeat center;
        }
        .img-input {
            display: none;
        }
        .icon-at{
            position: relative;
            cursor: pointer;
            width: 35px;
            height: 35px;
            background: url('../../images/icon_at@2x.png') no-repeat center;
            background-size: 18PX 18PX;
        }
        .icon-at:hover{
            background: url('../../images/icon_at_hover@2x.png') no-repeat center;
            background-size: 18PX 18PX;
        }
        .submit {
            margin-left: auto;
            width: 90px;
            height: 37px;
            font-size: 16px;
            font-family: "Microsoft YaHei";
            line-height: 37px;
            color: #fff;
            background: #d81519;
            cursor: pointer;
            text-align: center;
        }
    }
    .un-login-btns {
        padding: 0 0 0 10px;
        font-size: 14px;
        height: 35px;
        display: flex;
        align-items: center;
        background-color: #f8f8f8;
        .left {
            font-size: 13px;
            color: #333;
            display: flex;
            align-items: center;
            a {
                margin-right: 15px;
                width: 20px;
                height: 37px;
                cursor: pointer;
            }
            .instanse {
                background: url('../../images/sohu.png') no-repeat center;
            }
            .instanse:hover {
                background: url('../../images/sohu-active.png') no-repeat center;
            }
            .wechat {
                background: url('../../images/weixin.png') no-repeat center;
            }
            .wechat:hover {
                background: url('../../images/weixin-active.png') no-repeat center;
            }
            .wb {
                background: url('../../images/xinlang.png') no-repeat center;
            }
            .wb:hover {
                background: url('../../images/xinlang-active.png') no-repeat center;
            }
            .qq {
                background: url('../../images/qq.png') no-repeat center;
            }
            .qq:hover {
                background: url('../../images/qq-active.png') no-repeat center;
            }
        }
        .submit {
            margin-left: auto;
            width: 90px;
            height: 37px;
            font-size: 14px;
            font-family: "Microsoft YaHei";
            line-height: 37px;
            color: #fff;
            background: #d81519;
            cursor: pointer;
            text-align: center;
        }
    }
}
</style>
